export const AUTOMATICALLY_SELECTED_PLAN = 'standard'

export interface Account {
    accountId: string
    name: string
}

export interface Customer {
    quotationNumberKrones: any
    quotationNumberSyskron: any
    street: any
    city: any
    stateName: any
    country: any
    zipCode: any
    latitude: any
    longitude: any
    customerTimezone: string | null
    orderNumbersKrones: string[]
    orderNumbersSyskron: string[]
    s2aAccountName: string
    links: string[]
    version: number
    customerNumber: string
    salesRepresentative: string
    rkMonitoringHidden?: boolean
    accountProperties?: AccountProperties
    preferredLanguages?: string[]
    serviceGroups: string[]
    readyKitCount: number
    networkCommissioningNumber?: string
    salesRegion?: string
}

export interface ListCustomersResponse {
    items: Array<Customer>
    lastEvaluatedKey?: string
}

export interface Language {
    Name: string
    FullName: string
}

export enum S2aAccountStatus {
    Inactive = 'inactive',
    Active = 'active'
}

export interface S2aReadyKitProperties {
    [key: string]: string
    name: string
    cNumber: string
}

export interface AccountProperties {
    [key: string]: string
}

export interface Plan {
    planKey: string
}

export interface Tenant {
    tenantId: string // uuid
    tenantName: string
    description: string
}

export interface S2aBookedService {
    serviceId: string
    plan: Plan
    additionalProperties?: {[key: string]: unknown}
}

export enum S2aAccountState {
    Inactive = 'inactive',
    Active = 'active',
    Offboarding = 'offboarding',
    Offboarded = 'offboarded',
    Restore = 'restore'
}

export enum GdprDeletionStatus {
    InProgress = 'IN_PROGRESS',
    Completed = 'COMPLETED'
}

export interface OffboardingStatus {
    action: 'offboarding' | 'restore' | 'restoring'
    accountId: string
    services: Record<string, boolean>
    status: GdprDeletionStatus
}

export enum Ecosystem {
    Share2Act = 'share2act',
    Flash = 'flash'
}

export interface EcosystemOption {
    label: string
    value: string
}

export interface S2aAccount {
    accountId: string
    tenant?: Tenant
    services: S2aBookedService[]
    state: S2aAccountState
    deactivateComment?: string
    /** ISO datetime in UTC timezone */
    deactivatedAt?: string
    /** ISO datetime in UTC timezone */
    usersDataDeleteAt?: string
    /** ISO datetime in UTC timezone */
    offBoardingStartedAt?: string
    notifier?: string
    notifierEmail?: string
    telephoneNumber?: string
    personnelNumber?: string
    ecosystem?: Ecosystem
}

export interface S2aService {
    serviceId: string
    name: string
    plans: S2aPlan[]
    additionalProperties?: {
        key: string
        type: string // string, object, enumeration, array
        values?: unknown[] // for enum only
        required: boolean
    }[]
}

export interface S2aPlan {
    key: string
    features: string[]
}

export interface CreateCustomerResponse {
    progressToken: string
}

export interface GetCreateCustomerProgressResponse {
    status: string
}

export enum AccountStatus {
    Active = 'active',
    Inactive = 'inactive',
    Deleted = 'deleted'
}

export interface InactiveDeletedAccount {
    status: AccountStatus
    comment: string
    timestamp: number
}

export interface InactiveDeletedAccounts {
    [accountName: string]: InactiveDeletedAccount
}

export interface DeletedAccountsResponse {
    version: number
    s2aAccounts: InactiveDeletedAccounts
}

export interface BookedService {
    id: string
    planKey: string
    name: string
}

export interface CommentedAccount {
    id: string
    commentInactive: string
    commentDeleted: string
}

export interface AvailableGroup {
    id: string
    default?: boolean
    displayName: string
    requiredOcServices: string[]
    optionalOcServices: string[]
    requiredS2aServices: string[]
    optionalS2aServices: string[]
    defaultOptionalS2aServices?: string[]
}

export interface RegionCountry {
    region: string
    country: string
}

export interface OffboardingResponse {
    message: string
    accountId: string
    usersDataDeleteAt: string
}
